import { render, staticRenderFns } from "./BlankTemplate.vue?vue&type=template&id=150422f0&scoped=true&"
import script from "./BlankTemplate.vue?vue&type=script&lang=js&"
export * from "./BlankTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BlankTemplate.vue?vue&type=style&index=0&id=150422f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150422f0",
  null
  
)

export default component.exports